import React from 'react'
import createReactClass from 'create-react-class'
import {format} from '../../util/helpers'
import ErrorBlock from '../../elements/error-block'

export default createReactClass({

  renderRowItem (label, value, index) {
    return (
      <div className='no-gutter' key={'' + label + index}>
        <div className='col-lg-12 col-md-12'>
          <div className='col-lg-6 col-md-6'>
            <div className='row-label'>{format(label)}</div>
          </div>
          <div className='col-lg-6 col-md-6'>
            <div className='row-value'>{value}</div>
          </div>
        </div>
      </div>
    )
  },

  renderCardBody (row, index) {
    let rowItems = []
    for (const key in row) {
      rowItems.push(this.renderRowItem(key, row[key], index))
    }
    return (
      <div className='card-row-object' key={'Audit' + index}>
        <div className='card-row-object-title'>{`Audit - ${index + 1}`}</div>
        {rowItems}
      </div>
    )
  },
  renderRows () {
    return this.props.decisionTreeData.Audits.map((row, index) => {
      return this.renderCardBody(row, index)
    })
  },
  renderReturnedData () {
    return (
      <div className='col-md-6' key='card-returned-data'>
        <div className='card'>
          <div className='card-title'>Returned Data</div>
          <div className='card-body clearfix'>
            {this.props.decisionTreeData.Audits
              ? <div className='card-row-array'>
                <div className='card-row-array-title'>Audits</div>
                {this.renderRows()}
              </div>
              : null}
          </div>
        </div>
      </div>
    )
  },
  renderReturnedDecision () {
    return (
      <div className='col-md-6' key='card-returned-decision'>
        <div className='card'>
          <div className='card-title'>Returned Decision</div>
          <div className='card-body clearfix'>
            {this.renderRowItem('Decision', this.props.decisionTreeData.Decision, 'decision')}
            {this.props.decisionTreeData.DecisionText && this.props.decisionTreeData.DecisionText !== null
              ? this.renderRowItem('Decision Text', this.props.decisionTreeData.DecisionText, 'decisionText')
              : null}
          </div>
        </div>
      </div>
    )
  },

  getErrorMessage (error) {
    return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  render () {
    return (
      <div className="section-body clearfix">
        {this.props.error
          ? <div>
            <h4>Decision Engine</h4>
            <ErrorBlock {...this.props.error}/>
          </div>
          : <div>{this.props.selectedTree.GUID
            ? <div className='row'>
              {this.props.dataLoader ? <div className='loader-ctr'><span className="loading"></span></div>
                : this.props.dataError ? <ErrorBlock {...this.props.dataError}/>
                  : this.props.decisionTreeData
                    ? <div>
                      {this.renderReturnedDecision()}
                      {this.renderReturnedData()}
                    </div>
                    : null
              }
            </div> : null}
          </div>}
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/report-page/decision-tree-panel.js